<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库编号</label>
            <em class="weui-form-preview__value">{{form.wh_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库名称</label>
            <em class="weui-form-preview__value">{{form.wh_description}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库类型</label>
            <span class="weui-form-preview__value">{{form.wh_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料类型</label>
            <span class="weui-form-preview__value">{{form.wh_product_type}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库地址</label>
            <span class="weui-form-preview__value">{{form.wh_address}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/document/warehouse_edit?id='+form.id"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="form.wh_statuscode=='ENABLE'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(0,form.id)"
      >禁用</a>
      <a
        href="javascript:;"
        v-if="form.wh_statuscode!='ENABLE'"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_enable(1,form.id)"
      >启用</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_remove(null,form.id)"
      >删除</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/document/warehouse"
    };
  }
};
</script>